import * as React from 'react';
import styled from 'styled-components';
import { useClickoutside } from '../../../../../utils/hooks/useClickoutside';
import { ArrowIcon } from '../../../../ui/icons/Arrow';

interface IArgs {
  counties?: string[];
}

export const AreaSelect: React.FC<IArgs> = ({ counties = [], children }) => {
  const ref = React.useRef(null);
  const [open, setOpen] = React.useState(false);

  useClickoutside({
    ref,
    onClickOutside: () => {
      setOpen(false);
    }
  });

  const getSelectedLabel = () => {
    if (!counties?.length) return 'Velg område';
    const title = counties?.filter((e) => e?.length)?.join(',');
    if (!title?.length) return 'Velg område';
    return title;
  };

  return (
    <StyledAreaSelect
      ref={ref}
      onClick={() => {
        setOpen((prev) => !prev);
      }}
    >
      <StyledAreaSelectInsideWrapper>
        <div className="mask-label">
          <label>{getSelectedLabel()}</label>
        </div>
        <ArrowIcon className={open ? 'arrowdown open' : 'arrowdown'} />
      </StyledAreaSelectInsideWrapper>
      {open ? (
        <StyledAreaSelectWrapper>{children}</StyledAreaSelectWrapper>
      ) : null}
    </StyledAreaSelect>
  );
};

const StyledAreaSelect = styled.div`
  width: 100%;
  position: relative;
`;

const StyledAreaSelectWrapper = styled.div`
  position: absolute;
  top: 53px;
  width: 100%;
  padding: 1em;
  background: rgb(40, 40, 40);
  z-index: 2;
  max-height: 25.5em;
  overflow-x: hidden;
  overflow-y: scroll;
`;

const StyledAreaSelectInsideWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 53px;
  line-height: 53px;
  padding: 0 15px;
  background: ${(props: any) => props.theme.input.background};
  user-select: none;

  .mask-label {
    position: relative;
    width: 80%;
    height: 53px;
    overflow: hidden;
  }

  label {
    position: absolute;
    pointer-events: none;
    width: max-content;
    color: ${(props: any) => props.theme.input.color};
  }

  .arrowdown {
    display: flex;
    align-items: center;
    position: absolute;
    right: 0.8em;
    height: 20px;
    width: 20px;
    pointer-events: none;

    &.open {
      transform: rotate(180deg);
    }

    svg {
      width: inherit;
      height: inherit;
    }
    path {
      stroke: #fff;
    }
  }
`;
